import React from 'react';
import {Space} from 'antd';
import {FileTextOutlined} from '@ant-design/icons';

export default function PdfLink({url, label = 'Ver PDF'}) {
    if (!url) return '-';
    return (
        <a href={url} target="_blank" rel="noopener noreferrer">
            <Space>
                <FileTextOutlined/>
                {label}
            </Space>
        </a>
    );
}